import { createContext } from "react";
import type { AuthContextData } from "../../@types/contexts/Auth/AuthContext";

export const AuthContext = createContext<AuthContextData>(
  {} as AuthContextData,
);
